'use strict';

export const AssignOpeartorConstants = Object.freeze({
  REMOVE: 'remove',
  ADD: 'add',
});
